import Vue from "vue";

import { getImageUrlFromName } from "../../utilities/utilities";


function transformPost(post, currentUserID) {
  return {
    postID: post._id,
    authorID: post.poster.ID,
    authorImageUrl: getImageUrlFromName(post.poster.img),
    authorDisplayName: post.poster.name,
    dateTime: new Date(post.d),
    postReactionCounts: post.reactionCounts ? post.reactionCounts : {},
    postContent: post.post,
    poll: post.poll,
    nrReplies: post.nrReplies,
    lastUpdated: post.lastUpdated ? new Date(post.lastUpdated) : null,
    imageData: post.imageData,

    isCurrentUserAuthor: currentUserID === post.poster.ID,
  }
}

const getDefaultState = () => {
  return {
    /* array of post IDs */
    postIDs: [],
    /* keys: postID, values: the post object */
    posts: {},
  
  
    allPostsLoaded: false,
  
    /* keys: postID */
    allRepliesLoaded: {},
  
    postReplies: {},
  
    userPostReactions: {},
  
    userPollVotes: {},
  
    /* keys: replyID, values: reactionObjects */
    userReplyReactions: {},
  
    currentDropdown: {
      type: null,
      postID: null,
      replyID: null,
      postIndex: null,
    },
  
    pinnedPostIDs: [],
    currentPinnedInViewIndex: 0,
  };
}

const state = getDefaultState()


// const state = {

//   /* array of post IDs */
//   postIDs: [],
//   /* keys: postID, values: the post object */
//   posts: {},


//   allPostsLoaded: false,

//   /* keys: postID */
//   allRepliesLoaded: {},

//   postReplies: {},

//   userPostReactions: {},

//   userPollVotes: {},

//   /* keys: replyID, values: reactionObjects */
//   userReplyReactions: {},

//   currentDropdown: {
//     type: null,
//     postID: null,
//     replyID: null,
//     postIndex: null,
//   },

//   pinnedPostIDs: [],
//   currentPinnedInViewIndex: 0,
// };

const getters = {
  /* posts are from newest to oldest, replies are from oldest to newest */
  oldestPostDateTimeMS: (state) => {
    let postID = null;
    if (state.postIDs.length) postID = state.postIDs[state.postIDs.length - 1];
    console.log("@oldestPostDateTimeMS oldest ID: ", postID);
    if (postID) return state.posts[postID].dateTime.valueOf();
    return Date.now();
  },
  newestPostDateTimeMS: (state) => {
    let postID = null;
    if (state.postIDs.length) postID = state.postIDs[0];
    if (postID) return state.posts[postID].dateTime.valueOf();
    return 0;
  },
  oldestReplyDateTimeMS: (state) => (postID) => {
    if (state.postReplies[postID].length) return state.postReplies[postID][0].dateTime.valueOf();
    return Date.now();
  },
  newestReplyDateTimeMS: (state) => (postID) => {
    const replies = state.postReplies[postID];
    if (replies.length) return replies[replies.length - 1].dateTime.valueOf();
    return 0;
  },
  getUserPostReactions: (state) => (postID) => {
    return state.userPostReactions[postID] ? state.userPostReactions[postID] : {};
  },
  getUserPollVotes: (state) => (postID) => {
    return state.userPollVotes[postID] ? state.userPollVotes[postID] : {};
  },
  getUserReplyReactions: (state) => (replyID) => {
    return state.userReplyReactions[replyID] ? state.userReplyReactions[replyID] : {};
  },
};

const mutations = {
  RESET_STATE (state) {
    Object.assign(state, getDefaultState())
  },

  ADD_PINNED_POST(state, postID) {
    if (!state.pinnedPostIDs.includes(postID)) {
      state.pinnedPostIDs.push(postID);
      if (state.pinnedPostIDs.length > 3) {
        state.pinnedPostIDs = state.pinnedPostIDs.slice(-3)
      }
    }
    state.currentPinnedInViewIndex = state.pinnedPostIDs.length-1;
  },

  REMOVE_PINNED_POST(state, postID) {
    const idx = state.pinnedPostIDs.findIndex(x => x === postID);
    if (idx >= 0) {
      state.pinnedPostIDs.splice(idx, 1);
    }
    state.currentPinnedInViewIndex = Math.min(state.pinnedPostIDs.length-1, state.currentPinnedInViewIndex);
  },

  SET_CURRENT_PINNED_IN_VIEW(state, index) {
    state.currentPinnedInViewIndex = index;
  },

  SET_DROPDOWN(state, payload = null) {
    // console.log("make here", payload);
    if (payload === null) {
      state.currentDropdown = {
        type: null,
        postID: null,
        replyID: null,
        postIndex: false,
      };
    } else {
      state.currentDropdown.type = payload.type ? payload.type : null;
      state.currentDropdown.postID = payload.postID ? payload.postID : null;
      state.currentDropdown.replyID = payload.replyID ? payload.replyID : null;
      state.currentDropdown.postIndex = payload.postIndex;
    }
  },

  SET_ALL_POSTS_LOADED(state, newStatus) {
    state.allPostsLoaded = newStatus;
  },
  SET_ALL_POST_REPLIES_LOADED(state, payload) {
    Vue.set(state.allRepliesLoaded, payload.postID, payload.newStatus);
  },
  SET_USER_POST_REACTIONS(state, payload) {
    Vue.set(state.userPostReactions, payload.postID, payload.postReactions);
  },
  SET_USER_POLL_VOTES(state, payload) {
    Vue.set(state.userPollVotes, payload.postID, payload.postPollVotes);
  },
  SET_USER_REPLY_REACTIONS(state, payload) {
    Object.keys(payload).forEach((replyID) => {
      Vue.set(state.userReplyReactions, replyID, payload[replyID]);
    });
  },
  SET_NR_REPLIES(state, payload) {
    state.posts[payload.postID].nrReplies = payload.nrReplies;
  },
  /**
   * Just adds the post to the posts object, does not add to the postIDs array (used for pinned posts)
   */
  ADD_POST(state, post) {
    Vue.set(state.posts, post.postID, post);
  },
  /**
   * Posts are from newest to oldest.
   * @param {Boolean} newer whether to push to the back or to the front of the array
   * @param {Array} postArray the new posts to add. The array is sorted from newest to oldest.
   */
  APPEND_POSTS(state, payload) {
    const len = payload.postArray.length;
    for (let i = 0; i < len; i++) {
      const idx = payload.newer ? len - 1 - i : i;
      const post = payload.postArray[idx];
      if (payload.newer) {
        /* since the array is sorted from newest to oldest, we need to add the older ones first */
        state.postIDs.unshift(post.postID);
      } else {
        state.postIDs.push(post.postID);
      }
      Vue.set(state.posts, post.postID, post);
    }
  },
  /**
   * Replies are from oldest to newest
   * @param {String} postID the post ID to which the replies are posted
   * @param {Boolean} newer whether to push to the back or to the front of the array
   * @param {Array} replyArray the new replies to add. Replies are sorted from newest to oldest
   */
  APPEND_REPLIES_TO_POST(state, payload) {
    const { postID, newer, replyArray } = payload;
    if (!state.postReplies[postID]) {
      Vue.set(state.postReplies, postID, replyArray);
    } else {
      const length = replyArray.length;
      for (let i = 0; i < length; i++) {
        if (newer) {
          /* since the array is sorted from newest to oldest, we need to add the older ones first */
          state.postReplies[postID].push(replyArray[length - 1 - i]);
        } else {
          state.postReplies[postID].unshift(replyArray[i]);
        }
      }
    }
  },
  /**
   * @param {String} postID the ID of the post to update
   * @param {String} newPostText the new, updated post text
   * @param {Date} lastUpdated the last updated datetime
   */
  SET_POST_TEXT(state, payload) {
    state.posts[payload.postID].postContent = payload.newPostText;
    Vue.set(state.posts[payload.postID], "lastUpdated", payload.lastUpdated);
  },
  /**
   * @param {Number} replyIndex the index of the reply in the array
   * @param {String} postID the ID of the post under which the reply belonged to
   */
  DELETE_REPLY(state, payload) {
    const { postID, replyIndex } = payload;
    console.log("@DELETE REPLY PAYLOAD: ", postID, replyIndex);
    state.postReplies[postID][replyIndex].deleted = true;
    state.postReplies[postID][replyIndex].replierDisplayName = "Anonymous";
    state.postReplies[postID][replyIndex].replierID = null;
    state.postReplies[postID][replyIndex].replierImageUrl = null;
    state.postReplies[postID][replyIndex].replyContent = null;
  },
  /**
   * @param {String} postID
   * @param {Object} newOption the new option object (with keys idx, option, votes)
   */
  ADD_OPTION_TO_POLL(state, payload) {
    state.posts[payload.postID].poll.options.push(payload.newOption);
  },
  /**
   * Sets a poll option to voted by the user
   * @param {String} postID the postID of where the poll was
   * @param {Number} optionIndex
   * @param {Boolean} voted the vote status. True if the user just voted, false otherwise
   */
  UPDATE_POLL_VOTE(state, payload) {
    if (!state.userPollVotes[payload.postID]) {
      Vue.set(state.userPollVotes, payload.postID, { [payload.optionIndex]: payload.voted });
    } else {
      Vue.set(state.userPollVotes[payload.postID], payload.optionIndex, payload.voted);
    }
    const poll = state.posts[payload.postID].poll.options;
    console.log("@updatePollVote the poll: ", poll);
    for (let i = 0; i < poll.length; i++) {
      if (poll[i].idx === payload.optionIndex) {
        if (payload.voted) poll[i].votes += 1;
        else poll[i].votes -= 1;
        break;
      }
    }
  },
  /**
   * Updates vote count and user reaction status for the post and the corresponding reaction
   * @param {String} postID
   * @param {String} reactionType
   * @param {Boolean} reacted if true, reacted; if false, unreacted
   */
  UPDATE_USER_POST_REACTIONS(state, payload) {
    const { postID, reactionType, reacted } = payload;
    if (!state.userPostReactions[postID]) {
      Vue.set(state.userPostReactions, postID, { [reactionType]: reacted });
    } else {
      Vue.set(state.userPostReactions[postID], reactionType, reacted);
    }
    console.log("@UPDATE_USER_POST_REACTIONS", postID, reactionType, reacted);
    const post = state.posts[postID];
    console.log("@UPDATE_USER_POST_REACTIONS the post", post);
    const updateAmount = reacted ? 1 : -1;
    if (post.postReactionCounts[reactionType]) {
      post.postReactionCounts[reactionType] += updateAmount;
    } else if (reacted) {
      Vue.set(state.posts[postID].postReactionCounts, reactionType, 1);
    }
  },
  /**
   * @param {String} replyID the reply ID
   * @param {Number} replyIndex the reply index in the reply array
   * @param {String} postID the post ID under which the reply was provided
   * @param {String} reactionType
   * @param {Boolean} reacted if true, reacted; if false, unreacted
   */
  UPDATE_USER_REPLY_REACTIONS(state, payload) {
    const { replyID, replyIndex, postID, reactionType, reacted } = payload;
    if (!state.userReplyReactions[replyID]) {
      Vue.set(state.userReplyReactions, replyID, { [reactionType]: reacted });
    } else {
      Vue.set(state.userReplyReactions[replyID], reactionType, reacted);
    }
    const reply = state.postReplies[postID][replyIndex];
    const updateAmount = reacted ? 1 : -1;
    if (reply.replyReactionCounts[reactionType]) {
      reply.replyReactionCounts[reactionType] += updateAmount;
    } else if (reacted) {
      Vue.set(state.postReplies[postID][replyIndex].replyReactionCounts, reactionType, 1);
    }
  },
  DELETE_POST(state, payload) {
    const {postID, postIndex} = payload; 
    const replies = state.postReplies[postID];
    if (replies && replies.length) {
      for (let i=0; i<replies.length; i++) {
        Vue.delete(state.userReplyReactions, replies[i].replyID);
      }
    }
    Vue.delete(state.posts, postID);
    Vue.delete(state.postReplies, postID);
    Vue.delete(state.userPostReactions, postID);
    Vue.delete(state.userPollVotes, postID);
    state.postIDs.splice(postIndex, 1);
  }
};

const actions = {
  transformPostArray({ rootState, dispatch }, postArray) {
    console.log("@TransformPostArray the array: ", postArray);
    return postArray.map(post => {
      if (post.userInteractions && post.userInteractions.length) {
        dispatch("updateUserInteractions", { postID: post._id, userInteractions: post.userInteractions[0] });
      }
      // console.log("@addPostArray post replies: ", post.replies);
      if (post.replies && !state.postReplies[post._id]) 
        dispatch("addReplyArray", { postID: post._id, newer: true, replyArray: post.replies });
      return transformPost(post, rootState.auth.user._id);
    });
  },

  async addPostArray({ commit, dispatch }, payload) {
    const { newer, postArray } = payload;
    const posts = await dispatch("transformPostArray", postArray);
    commit("APPEND_POSTS", { newer, postArray: posts });
  },

  /**
   * @param {Array} pinnedPosts the array of pinned posts
   */
  async addPinnedPostsFromDB({ commit, dispatch }, pinnedPosts) {
    const posts = await dispatch("transformPostArray", pinnedPosts);
    for (let i=0; i<posts.length; i++) {
      commit("ADD_POST", posts[i]);
      commit("ADD_PINNED_POST", posts[i].postID);
    }
  },

  addReplyArray({ commit, rootState }, payload) {
    const { postID, newer, replyArray } = payload;
    const replies = replyArray.map((reply) => {
      return {
        replyID: reply._id,
        replierID: reply.replier ? reply.replier.ID : null,
        replierImageUrl: reply.replier ? getImageUrlFromName(reply.replier.img) : null,
        replierDisplayName: reply.replier ? reply.replier.name : "Anonymous",
        dateTime: new Date(reply.d),
        replyContent: reply.msg,
        replyReactionCounts: reply.reactionCounts ? reply.reactionCounts : {},
        deleted: !!reply.deleted,

        isCurrentUserAuthor: reply.replier ? rootState.auth.user._id === reply.replier.ID : false,
      };
    });
    // console.log("new replies to add!!", replies);
    commit("APPEND_REPLIES_TO_POST", { postID, newer, replyArray: replies });
  },

  updateUserInteractions({ commit }, payload) {
    const { postID, userInteractions } = payload;
    const { reactions, pollVotes, replyReactions } = userInteractions;
    if (reactions) {
      const postReactions = {};
      for (let i = 0; i < reactions.length; i++) {
        postReactions[reactions[i]] = true;
      }
      commit("SET_USER_POST_REACTIONS", { postID, postReactions });
    }
    if (pollVotes) {
      const postPollVotes = {};
      for (let i = 0; i < pollVotes.length; i++) {
        postPollVotes[pollVotes[i]] = true;
      }
      commit("SET_USER_POLL_VOTES", { postID, postPollVotes });
    }
    if (replyReactions) {
      const userReplyReactions = {};
      for (let i = 0; i < replyReactions.length; i++) {
        const replyID = replyReactions[i].RID;
        if (Object.prototype.hasOwnProperty.call(replyID, userReplyReactions)) {
          userReplyReactions[replyID][replyReactions[i].react] = true;
        } else {
          userReplyReactions[replyID] = { [replyReactions[i].react]: true };
        }
      }
      commit("SET_USER_REPLY_REACTIONS", userReplyReactions);
    }
  },
};

const community = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};

export default community;
